import { SPECIAL_DISPLAY_BRAND_NAMES } from 'brand/enum/brands';

/**
 * [startCase]
 *  very similar to lodash method startCase, minus the removal of ALL special characters. Just removes dashes and underscores.
 * @param  {string} facetValue  a string formatted like so 'new-balance' that needs to be in titlecase and have its dashes removed
 * @return {string}        returns a string with the first letter of each word capitalized and only removes dashes and no other special characters
 * ...('chloé') -> 'Chloé'
 * ...('nike') -> Nike
 * ...('off-white') -> 'Off White'
 * ...('acne_studios') -> Acne Studios
 * ...('asics') -> 'ASICS' --> asics is a part of the special case brands that are included in the import SPECIAL_STRING_DISPLAY_MAP from strings utils
 */
export const startCase = (facetValue: string, ignoreSpecialDispay = false) => {
  if (SPECIAL_DISPLAY_BRAND_NAMES[facetValue] && !ignoreSpecialDispay)
    return SPECIAL_DISPLAY_BRAND_NAMES[facetValue];
  try {
    const formattedString = facetValue
      .replace(/-/g, ' ')
      .replace(/_/g, ' ')
      .split(' ')
      // eslint-disable-next-line unicorn/no-array-reduce
      .reduce((acc, curr) => {
        return `${acc} ${curr.charAt(0).toUpperCase() + curr.slice(1)}`;
      }, '');

    if (formattedString.charAt(0) === ' ') {
      return formattedString.slice(1);
    }

    return formattedString;
  } catch {
    return facetValue;
  }
};
